import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1e3bfbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content bg-xr-card text-white p-4 pt-2" }
const _hoisted_3 = { class: "modal-header border-0 px-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "staticBackdropLabel"
}, "Token Photo", -1))
const _hoisted_5 = {
  type: "button",
  class: "text-gray-text btn",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_6 = { class: "modal-body p-2 pt-0 mt-0" }
const _hoisted_7 = { class: "image-upload-container" }
const _hoisted_8 = { class: "img-upload border-theme" }
const _hoisted_9 = { class: "modal-footer mt-5 border-top-theme" }
const _hoisted_10 = { class: "left-buttons float-start" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Add Photo")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_13 = { class: "right-buttons float-end" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", _hoisted_5, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-close",
            style: {"font-size":"20px"}
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.previewImage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "imagePreviewWrapper",
                  style: _normalizeStyle({ 'background-image': `url(${_ctx.previewImage})` })
                }, null, 4))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileInput.click())),
            class: "btn bg-xr-body me-2"
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-solid fa-camera",
              class: "text-blue-primary inline-block"
            }),
            _hoisted_11
          ]),
          _createElementVNode("input", {
            style: {"display":"none"},
            ref: "fileInput",
            type: "file",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
            accept: ".png, .jpg, .jpeg"
          }, null, 544),
          _createElementVNode("button", {
            class: _normalizeClass(["btn bg-xr-body me-2", [!_ctx.previewImage ? 'opacity50' : '']]),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-solid fa-trash",
              class: "text-white inline-block"
            }),
            _hoisted_12
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn btn-primary float-end px-5", [!_ctx.previewImage ? 'opacity50' : '']]),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateImage && _ctx.updateImage(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-solid fa-save",
              class: "inline-block"
            }),
            _hoisted_14
          ], 2)
        ])
      ])
    ])
  ]))
}